export default {};
export const API_URL = '/api/';
export const shopifyURL = document.body.dataset.shopUrl.replace('https://', '');